import NoRecordFound from "../../components/common/no-record-found/NoRecordFound";

// DEFAULT COLORS
export const DEFAULT_COLORS = [
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
  "#EC4899",
];

// COLOR RESOLVER
export const resolveChartColors = ({
  colorType,
  data,
  series,
  xKey,
  STATUS_COLOR_MAP
}) => {
  if (colorType === "status") {
    if (Array.isArray(series) && series[0]?.name) {
      return series.map(s => STATUS_COLOR_MAP[s.name] || "#ccc");
    }

    return data.map(item => STATUS_COLOR_MAP[item[xKey]] || "#ccc");
  }

  return DEFAULT_COLORS;
};

// LOADER (PrimeReact)
export const renderChartLoader = () => (
  <div className="chart-loader">
    <i className="pi pi-spinner pi-spin" />
    <span className="loader-text">Loading Chart Data....</span>
  </div>
);

// NO DATA
export const renderNoData = (message) => (
  <div className="empty-chart-placeholder">
    <NoRecordFound message={message || "No data available"} />
  </div>
);

// DATA CHECK
export const checkHasData = ({ type, series }) => {
  if (type === "pie" || type === "donut") {
    return Array.isArray(series) && series.some(v => v > 0);
  }

  return (
    Array.isArray(series) &&
    series.length > 0 &&
    series.some(s => s.data?.length > 0)
  );
};